import { useNavigation } from "@react-navigation/native";
import { AHEmptyScreen, Box } from "arkh";

import React, { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import Stretch from "./stretch.json";
import { Lottie, LottieRef } from "../../components/Lottie";

export const NoTodosComponent = React.memo(InnerNoTodosComponent);

function InnerNoTodosComponent(props: {
  categoryTitle: string;
  color: string;
  teamName: string;
  mode: "ALL" | "ME";
}) {
  const ref = useRef<LottieRef>(null);

  const nav = useNavigation();
  useEffect(() => {
    // hack to get lottie to play
    const listener = nav.addListener("transitionEnd" as any, () => {
      ref.current?.play();
    });
    ref.current?.play();
    return () => {
      listener();
    };
  }, [nav]);

  return (
    <Box style={{ flex: 1 }} color="surface">
      <AHEmptyScreen
        illustration={<Lottie source={Stretch} autoPlay loop />}
        title={
          props.mode === "ALL" ? (
            <FormattedMessage
              description="TodoCategory Empty Screen Title All"
              defaultMessage="No {categoryTitle} exist in this team"
              values={{ categoryTitle: props.categoryTitle }}
            />
          ) : (
            <FormattedMessage
              description="TodoCategory Empty Screen Title Assigned"
              defaultMessage="No {categoryTitle} assigned to you"
              values={{ categoryTitle: props.categoryTitle }}
            />
          )
        }
        subtitle={
          props.mode === "ALL" ? (
            <FormattedMessage
              description="TodoCategory Empty Screen SubTitle All"
              defaultMessage="All {categoryTitle} associated with {teamName} are displayed here."
              values={{
                categoryTitle: props.categoryTitle,
                teamName: props.teamName,
              }}
            />
          ) : (
            <FormattedMessage
              description="TodoCategory Empty Screen SubTitle Assigned"
              defaultMessage="All {categoryTitle} assigned to you on {teamName} are displayed here."
              values={{
                categoryTitle: props.categoryTitle,
                teamName: props.teamName,
              }}
            />
          )
        }
      />
    </Box>
  );
}
